<div class="text-center button-container">
  <ng-template #popContent>
    <div class="message-delete">
        <p>{{messageDelete}}</p>
    </div>
    <div class="button-response">
      <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}"></breeze-button>
      <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="confirm()"></breeze-button>
    </div>
  </ng-template>
  <i [iconName]="'delete'" (click)="emitData()" [fillColor]="'#93a4aa'"
  placement="left" [ngbPopover]="popContent" container="body" id="delete-item" pTooltip="{{'icon.delete.tooltip'|translate}}" tooltipPosition="left">
  </i>
</div>
